export const environment = {
  production: false,
  isLocal: false,
  baseURL: 'https://devsmart.customs.gov.kg/smart-customs',
};
